import { storeCreator } from '@/utils/store/store.utils';

interface State {
  highlightedTaxFormId: string;
  setHighlightedTaxFormId: (id: string) => void;
  resetHighlight: () => void;
}

const useStore = storeCreator<State>((set) => ({
  highlightedTaxFormId: '',

  setHighlightedTaxFormId: (id: string) => set(() => ({
    highlightedTaxFormId: id,
  })),

  resetHighlight: () => set(() => ({
    highlightedTaxFormId: '',
  })),
}));

export default useStore;
